import { Dialog, DialogFooter, DialogType } from "@fluentui/react";
import React, { createContext, useContext } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import FiscalizationStore from "../productiontarget/store/FiscalizationStore";
import { ContextualMenu } from "@fluentui/react/lib/ContextualMenu";
import { Button, Input, notification } from "antd";
import { Formik } from "formik";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import * as yup from "yup";
import { FiscalizationUploadDialog } from "./FiscalizationUploadDialog";
const fiscalizationstore = createContext(FiscalizationStore);

const dragOptions = {
  moveMenuItemText: "Move",
  closeMenuItemText: "Close",
  menu: ContextualMenu,
};

const modalPropsStyles = { main: { maxWidth: 600 } };

export const FiscalizationEditDialog = observer(() => {
  const fiscalizationStore = useContext(fiscalizationstore);
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: dragOptions,
    }),
    []
  );
  return (
    <Dialog
      hidden={!fiscalizationStore.showTargetEditDialog}
      onDismiss={() => {
        fiscalizationStore.showTargetEditDialog = false;
      }}
      dialogContentProps={{
        type: DialogType.normal,
        title: `Set ${fiscalizationStore?.selRow.fiscalizationMonthModified} Fiscalized Production Figure`,
        titleProps: { style: { fontSize: "14px" } },
        subText: (
          <span style={{ color: "red" }}>
            Note:Changes to fiscalized figures is always logged
          </span>
        ),
      }}
      modalProps={modalProps}
      minWidth={400}
    >
      <Formik
        initialValues={fiscalizationStore.selRow}
        validationSchema={yup.object().shape({
          numberOfDays: yup
            .number()

            .required("Number of days produced is required"),

          grossFiscalized: yup
            .number()
            .required("Gross fiscalized(bbl) figures is required"),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            let fiscal = { ...toJS(values) };
            fiscal.grossFiscalized = Number(fiscal.grossFiscalized);

            const retVal = await fiscalizationStore.saveMonthFiscalization(
              fiscal
            );
            console.log(fiscal);
            if (retVal.success) {
              const savedFiscal = retVal.fiscalization;
              fiscalizationStore.fiscalizations.set(
                savedFiscal.fiscalizationId,
                {
                  ...savedFiscal,
                }
              );

              fiscalizationStore.showTargetEditDialog = false;
              notification.success({
                message: "SPARS Feedback",
                description: `${fiscal.fiscalizationMonthModified} fiscalization figures saved successfully`,
              });
            }
          } catch (error) {
            notification.error({
              key: "error",
              message: "SPARS Feedback",
              description: error.message,
            });
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,

          handleSubmit,
          isSubmitting,
        }) => (
          <Form layout="vertical" onFinish={handleSubmit}>
            <FormItem
              label="Production Days"
              required
              help={touched.numberOfDays && errors.numberOfDays}
            >
              <Input
                placeholder="Number of days produced"
                name="numberOfDays"
                value={values.numberOfDays}
                onChange={handleChange}
                allowClear
              />
            </FormItem>
            <FormItem
              label="Gross Fiscalized"
              required
              help={touched.grossFiscalized && errors.grossFiscalized}
            >
              <Input
                placeholder="Gross ficalization figure in bbls"
                name="grossFiscalized"
                value={values.grossFiscalized}
                onChange={handleChange}
                allowClear
              />
            </FormItem>
            <DialogFooter>
              <Button
                type="link"
                onClick={() => {
                  fiscalizationStore.showTargetEditDialog = false;
                }}
              >
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={isSubmitting}>
                Save
              </Button>
            </DialogFooter>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
});

